export default {
  background_image: 'Imagem de fundo',
};
